import axios from "./axios.service";

export const sendSupportRequest = (
  data
) => {
  return axios
    .post("/support", data)
    .then((res) =>
      res?.reference
        ? res
        : res?.data || res
    );
};
